import queryString from 'query-string';
import http from '.';
import { apiCourseSchedule, apiQrCode, apiRegions } from './apiRouter';

const getCourses = (body) => {
  const params = queryString.stringify(body);
  return http.get(`${apiCourseSchedule}?${params}`);
};

const getDetail = (id) => {
  return http.get(`${apiCourseSchedule}/${id}`);
};

const getRegions = () => http.get(apiRegions);
const getQrCode = () => http.get(apiQrCode);

const deleteCourse = (id) => http.delete(`${apiCourseSchedule}/${id}`);

const createCourseSchedule = (body) => http.post(apiCourseSchedule, body);

const updateCourse = (id, bodyData) => {
  return http.patch(`${apiCourseSchedule}/${id}`, bodyData);
};

const getQRInSchedule = (id) => {
  return http.get(`${apiCourseSchedule}/${id}/qr-code`);
};

const downloadQR = (id, body) => {
  return http.post(`${apiCourseSchedule}/${id}/qr-code/download`, body);
};

const sendMailWithQR = (id, body) => {
  return http.post(`${apiCourseSchedule}/${id}/send-mail`, body);
};

const setTextWithQR = (id, body) => {
  return http.put(`${apiCourseSchedule}/${id}/qr-code`, body);
};

const getStudentList = (id, body) => {
  const params = queryString.stringify(body);
  return http.get(`${apiCourseSchedule}/${id}/users-register?${params}`);
};

const changeStatus = (id, body) => {
  return http.put(`${apiCourseSchedule}/${id}/status`, body);
};

const changeVisible = (id) => {
  return http.put(`${apiCourseSchedule}/${id}/visibility`)
}

const CourseScheduleServices = {
  getCourses,
  deleteCourse,
  getDetail,
  updateCourse,
  getRegions,
  createCourseSchedule,
  getQrCode,
  getQRInSchedule,
  downloadQR,
  sendMailWithQR,
  setTextWithQR,
  getStudentList,
  changeStatus,
  changeVisible
};

export default CourseScheduleServices;
